import { TeamMember } from "../models/TeamMember";
import api from "./api";

const BASE_PATH = "/api/v1/memberships";

export const TeamMemberService = {
  async getTeamMembers(matterId: string): Promise<TeamMember[]> {
    const res = await api.get(`${BASE_PATH}`, {
      params: { matterId },
    });
    return res.data.data ?? [];
  },

  async createTeamMember(
    teamMemberData: Omit<
      TeamMember,
      "_id" | "createdAt" | "updatedAt" | "createdById" | "updatedById"
    >,
  ): Promise<string> {
    const res = await api.post(`${BASE_PATH}`, teamMemberData);
    return res.data?.data?._id;
  },

  async updateTeamMember(
    teamMemberId: string,
    updatedData: Partial<TeamMember>,
  ): Promise<void> {
    await api.patch(`${BASE_PATH}/${teamMemberId}`, updatedData);
  },

  async deleteTeamMemberById(teamMemberId: string): Promise<void> {
    await api.delete(`${BASE_PATH}/${teamMemberId}`);
  },
};
